import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "m-2 contact-access-section" }
const _hoisted_2 = { class: "dialog-custom__content form-custom" }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = { class: "mb-3 d-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "section-header" }
const _hoisted_6 = { class: "bt-icon bt-icon--xs" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "bt-icon my-auto bt-icon--m" }, [
  /*#__PURE__*/_createVNode("span", { class: "bt-icon bt-icon--sm" }, [
    /*#__PURE__*/_createVNode("i", { class: "pi pi-user" })
  ])
], -1)
const _hoisted_10 = { class: "card__head d-flex flex-column w-100" }
const _hoisted_11 = { class: "ml-3 d-flex flex-column" }
const _hoisted_12 = { class: "bt-icon bt-icon--sm" }
const _hoisted_13 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_14 = { class: "btn-stripped d-flex align-items-center text-danger" }
const _hoisted_15 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_16 = { class: "section-header mb-3 " }
const _hoisted_17 = { class: "d-flex flex-wrap" }
const _hoisted_18 = {
  key: 0,
  class: "param-field"
}
const _hoisted_19 = {
  class: "p-field-label",
  for: "scsAddr"
}
const _hoisted_20 = {
  key: 0,
  for: "scsAddr",
  class: "fs-13 label-error"
}
const _hoisted_21 = {
  key: 1,
  class: "param-field"
}
const _hoisted_22 = {
  class: "p-field-label",
  for: "buildingCode"
}
const _hoisted_23 = {
  key: 2,
  class: "param-field"
}
const _hoisted_24 = {
  class: "p-field-label",
  for: "riserCode"
}
const _hoisted_25 = {
  key: 3,
  class: "param-field"
}
const _hoisted_26 = {
  class: "p-field-label",
  for: "floorCode"
}
const _hoisted_27 = {
  key: 4,
  class: "param-field"
}
const _hoisted_28 = {
  class: "p-field-label",
  for: "apartmentCode"
}
const _hoisted_29 = { class: "mb-5" }
const _hoisted_30 = { class: "mb-3 d-flex justify-content-between align-items-center" }
const _hoisted_31 = { class: "section-header" }
const _hoisted_32 = { class: "bt-icon bt-icon--xs" }
const _hoisted_33 = { class: "ml-2" }
const _hoisted_34 = {
  key: 0,
  class: "text-gray"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_37 = { class: "card__head d-flex flex-column w-100" }
const _hoisted_38 = { class: "ml-3 d-flex flex-column" }
const _hoisted_39 = { class: "text-dark" }
const _hoisted_40 = {
  key: 0,
  class: "fs-14"
}
const _hoisted_41 = {
  key: 1,
  class: "fs-14"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_Card = _resolveComponent("Card")
  const _component_InputText = _resolveComponent("InputText")
  const _component_DialogEditLabel = _resolveComponent("DialogEditLabel")
  const _component_DialogInviteResident = _resolveComponent("DialogInviteResident")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('AppResourceEP.Labels')), 1),
              (!_ctx.isFloorsAddressing && !_ctx.isCallWithCode)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
                    class: "p-button-rounded p-button-outlined",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onAddLabelClick()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_6, [
                        _createVNode(_component_InlineSvgScoped, {
                          src: require(`@/assets/images/icons/icon-plus-outline.svg`)
                                    ,
                          "aria-label": "icon-grid"
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('AppResource.Add')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.apartment.labels, (label) => {
              return (_openBlock(), _createBlock(_component_Card, {
                class: "apartment-card my-3 card--slim",
                key: label.labelId
              }, {
                content: _withCtx(() => [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.getLabelText(label)), 1)
                    ]),
                    _createVNode(_component_ElDropdown, {
                      trigger: "click",
                      placement: "bottom-end",
                      "popper-class": "el-dropdown__popper el-dropdown--context"
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ElDropdownItem, {
                              disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
                              onClick: ($event: any) => (_ctx.onEditLabelClick(label))
                            }, {
                              default: _withCtx(() => [
                                _createVNode("button", _hoisted_13, [
                                  _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]),
                            _createVNode(_component_ElDropdownItem, {
                              disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
                              onClick: ($event: any) => (_ctx.onDeleteLabelClick(label.labelId ?? ''))
                            }, {
                              default: _withCtx(() => [
                                _createVNode("button", _hoisted_14, [
                                  _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Button, { class: "p-button-text p-1" }, {
                          default: _withCtx(() => [
                            _createVNode("span", _hoisted_12, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: require(`@/assets/images/icons/icon-ellipsis-v.svg`),
                                "aria-label": "icon-ellipsis-v"
                              }, null, 8, ["src"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          (_ctx.isFloorsAddressing || !_ctx.adminView)
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('AppResource.Parameters')), 1)
                ]),
                _createVNode("div", _hoisted_17, [
                  (!_ctx.adminView)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("AppResource.Address")), 1),
                        _createVNode(_component_InputText, {
                          disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                          id: "scsAddr",
                          type: "number",
                          class: "w-100",
                          modelValue: _ctx.apartment.scsAddr,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.apartment.scsAddr = $event)),
                          min: _ctx.MIN_SCS_ADDRESS,
                          max: _ctx.MAX_SCS_ADDRESS
                        }, null, 8, ["disabled", "modelValue", "min", "max"]),
                        (_ctx.scsAddrNotValid)
                          ? (_openBlock(), _createBlock("label", _hoisted_20, _toDisplayString(_ctx.$t("AppResource.Invalidaddress")), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isFloorsAddressing)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("AppResourceEP.Building")), 1),
                        _createVNode(_component_InputText, {
                          disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                          id: "buildingCode",
                          type: "number",
                          class: "w-100",
                          modelValue: _ctx.apartment.buildingCode,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.apartment.buildingCode = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isFloorsAddressing)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                        _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
                        _createVNode(_component_InputText, {
                          disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                          id: "riserCode",
                          type: "number",
                          class: "w-100",
                          modelValue: _ctx.apartment.riserCode,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.apartment.riserCode = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isFloorsAddressing)
                    ? (_openBlock(), _createBlock("div", _hoisted_25, [
                        _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("AppResourceEP.Floor")), 1),
                        _createVNode(_component_InputText, {
                          disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                          id: "floorCode",
                          type: "number",
                          class: "w-100",
                          modelValue: _ctx.apartment.floorCode,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.apartment.floorCode = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isFloorsAddressing)
                    ? (_openBlock(), _createBlock("div", _hoisted_27, [
                        _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("AppResourceEP.Apartment")), 1),
                        _createVNode(_component_InputText, {
                          disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                          id: "apartmentCode",
                          type: "number",
                          class: "w-100",
                          modelValue: _ctx.apartment.apartmentCode,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.apartment.apartmentCode = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('AppResource.Invitations')), 1),
              _createVNode(_component_Button, {
                class: ["p-button-rounded p-button-outlined", { disabled: !_ctx.currentEntrancePlant.syncStatus?.isPlantActive }],
                disabled: !_ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                onClick: _ctx.toggleInviteDialog
              }, {
                default: _withCtx(() => [
                  _createVNode("span", _hoisted_32, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: require(`@/assets/images/icons/icon-plus-outline.svg`)
                                    ,
                      "aria-label": "icon-grid"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('AppResource.Invite')), 1)
                ]),
                _: 1
              }, 8, ["class", "disabled", "onClick"])
            ]),
            (_ctx.currentInvitations.length === 0)
              ? (_openBlock(), _createBlock("small", _hoisted_34, _toDisplayString(_ctx.$t('entrancePlant.noUserInvitedYet')), 1))
              : (_openBlock(), _createBlock("div", _hoisted_35, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentInvitations, (cInvitation) => {
                    return (_openBlock(), _createBlock(_component_Card, {
                      class: "apartment-card my-3 card--slim",
                      key: cInvitation.email
                    }, {
                      content: _withCtx(() => [
                        _createVNode("div", _hoisted_36, [
                          _createVNode("div", {
                            class: ["avatar", cInvitation.status == 0 ? 'avatar__disabled' : 'avatar__enabled']
                          }, _toDisplayString(_ctx.userInitials(cInvitation)), 3),
                          _createVNode("div", _hoisted_37, [
                            _createVNode("div", _hoisted_38, [
                              _createVNode("div", {
                                class: "d-flex flex-column",
                                style: { opacity: cInvitation.status == 0 ? '.5' : '1' }
                              }, [
                                _createVNode("span", _hoisted_39, _toDisplayString(cInvitation.email ?? ""), 1),
                                (cInvitation.status == 0)
                                  ? (_openBlock(), _createBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('AppResource.InvitePending')), 1))
                                  : _createCommentVNode("", true),
                                (cInvitation.status == 1)
                                  ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('AppResource.InviteAccepted')), 1))
                                  : _createCommentVNode("", true)
                              ], 4)
                            ])
                          ]),
                          _createVNode(_component_Button, {
                            class: "text-danger ml-auto p-button-text",
                            disabled: cInvitation.status == 0,
                            style: { opacity: cInvitation.status == 0 ? '.5' : '1' },
                            onClick: ($event: any) => (_ctx.toggleDeleteInviteConfirm(cInvitation))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "style", "onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
          ])
        ])
      ])
    ]),
    _createVNode(_component_DialogEditLabel, {
      isVisible: _ctx.isVisibleDialogEditLabel,
      labelToEdit: _ctx.labelToEdit,
      isEdit: _ctx.isEdit,
      addressingType: _ctx.currentEntrancePlant.addressingType,
      onHideDialog: _ctx.hideLabelDialog,
      onSaveLabel: _ctx.onSaveLabel
    }, null, 8, ["isVisible", "labelToEdit", "isEdit", "addressingType", "onHideDialog", "onSaveLabel"]),
    _createVNode(_component_DialogInviteResident, {
      isVisible: _ctx.isVisibleDialogInviteResident,
      apartment: _ctx.apartment,
      onUpdateList: _ctx.handleUpdateList,
      onHideDialog: _ctx.toggleInviteDialog
    }, null, 8, ["isVisible", "apartment", "onUpdateList", "onHideDialog"]),
    _createVNode(_component_DialogConfirmDelete, {
      "is-visible": _ctx.isVisibleDeleteInviteConfirm,
      title: _ctx.$t('AppResourceEP.RemoveInvitedUser'),
      message: _ctx.$t('AppResourceEP.ConfirmRemoveInvitedUser'),
      onHideDialog: _ctx.toggleDeleteInviteConfirm,
      onConfirm: _ctx.handleDeleteInvite
    }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"])
  ], 64))
}